/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Mobile bottom navigation bar. Renders the post-launch or pre-launch variant
 * depending on the early-access feature flag.
 */

import React from 'react';
import { FF_EARLY_ACCESS } from '@/shared/utils/feature-flag';
import { useBottomNavHeight } from '@/shared/hooks/use-bottom-nav-height';
import type { MobileNavProps } from './MobileNav.types';
import { PostLaunchMobileNav } from './MobileNav.post-launch';
import { PreLaunchMobileNav } from './MobileNav.pre-launch';

export const MobileNav: React.FC<MobileNavProps> = (props) => {
  useBottomNavHeight(true);
  if (!FF_EARLY_ACCESS) {
    return <PostLaunchMobileNav {...props} />;
  }
  return <PreLaunchMobileNav {...props} />;
};
